export const InsuredFields = {
  firstName: 'firstName',
  lastName: 'lastName',
  birthDate: 'birthDate',
  insuranceStartDate: 'insuranceStartDate',
  insuranceBeginDate: 'insuranceBeginDate',
  groupInsurancePolicyId: 'groupInsurancePolicyId',
  groupInsurancePolicy: 'groupInsurancePolicy',
  insurancePolicyId: 'insurancePolicyId',
  insurancePolicy: 'insurancePolicy',
  insuredType: 'insuredType',
  phone: 'phone',
  email: 'email',
  citizenship: 'citizenship',
  maritalStatus: 'maritalStatus',
  certificateNumber: 'certificateNumber',
  uadVisaNumber: 'uadVisaNumber',
  emiratesIdNumber: 'emiratesIdNumber',
  passportNo: 'passportNo',
  dhaNumber: 'dhaNumber',
  sex: 'sex',
  insuranceEndDate: 'insuranceEndDate',
  principalFullName: 'principalFullName',
  // Files
  passportCdnFileId: 'passportCdnFileId',
  emiratesIdNumberCdnFileId: 'emiratesIdNumberCdnFileId',
  contractCdnFileId: 'contractCdnFileId',
  uadVisaNumberCdnFileId: 'uadVisaNumberCdnFileId',

  // Except fields
  patronymicName: 'patronymicName',
  deactivationDate: 'deactivationDate',
  maternalLastName: 'maternalLastName',
  subGroup: 'subGroup',
  additionalComments: 'additionalComments',
};

export const AddInsuredFields = {
  optionalFields: [
    InsuredFields.insuranceBeginDate,
    InsuredFields.insuranceEndDate,
    InsuredFields.phone,
    InsuredFields.email,
    InsuredFields.patronymicName,
    InsuredFields.citizenship,
    InsuredFields.certificateNumber,
    InsuredFields.emiratesIdNumber,
    InsuredFields.dhaNumber,
    InsuredFields.uadVisaNumber,
    InsuredFields.maritalStatus,
    InsuredFields.sex,
    InsuredFields.maternalLastName,
    InsuredFields.subGroup,
    InsuredFields.additionalComments,
  ],
  requiredFields: [
    InsuredFields.firstName,
    InsuredFields.lastName,
    InsuredFields.birthDate,
    InsuredFields.insuranceStartDate,
    InsuredFields.insuredType,
    InsuredFields.groupInsurancePolicyId,
  ],
  scansFields: [
    InsuredFields.passportCdnFileId,
    InsuredFields.emiratesIdNumberCdnFileId,
    InsuredFields.uadVisaNumberCdnFileId,
  ],
  formRequiredElements: [
    {
      name: InsuredFields.firstName,
      isRequired: false,
      type: 'TEXT',
    },
    {
      name: InsuredFields.lastName,
      isRequired: false,
      type: 'TEXT',
    },
    {
      name: InsuredFields.birthDate,
      isRequired: false,
      type: 'DATE',
    },
    {
      name: InsuredFields.insuranceStartDate,
      isRequired: false,
      type: 'DATE',
    },
    {
      name: InsuredFields.insuredType,
      isRequired: false,
      type: 'ENUM',
    },
    {
      name: InsuredFields.groupInsurancePolicyId,
      isRequired: false,
      type: 'ENUM',
    },
  ],
};
export const DeactivateInsuredFields = {
  optionalFields: [],
  requiredFields: [InsuredFields.insuranceEndDate],
  scansFields: [InsuredFields.contractCdnFileId],
};

export const InsuredFieldsSettingsTitle = {
  // Adding
  [InsuredFields.firstName]: 'adminTitles.firstName',
  [InsuredFields.lastName]: 'adminTitles.lastName',
  [InsuredFields.birthDate]: 'adminTitles.Birthdate',
  [InsuredFields.insuranceStartDate]: 'adminTitles.InsuranceStartDate',
  [InsuredFields.insuranceBeginDate]: 'adminTitles.insuranceBeginDate',
  [InsuredFields.insuranceEndDate]: 'adminTitles.InsuranceEndDate',
  [InsuredFields.groupInsurancePolicyId]: 'adminTitles.InsurancePolicy',
  [InsuredFields.groupInsurancePolicy]: 'adminTitles.InsurancePolicy',
  [InsuredFields.insurancePolicyId]: 'adminTitles.InsurancePolicy',
  [InsuredFields.insurancePolicy]: 'adminTitles.InsurancePolicy',
  [InsuredFields.insuredType]: 'adminTitles.TypeOfInsured',
  [InsuredFields.phone]: 'adminTitles.phone',
  [InsuredFields.email]: 'adminTitles.email',
  [InsuredFields.patronymicName]: 'adminTitles.patronymic',
  [InsuredFields.citizenship]: 'adminTitles.nationality',
  [InsuredFields.certificateNumber]: 'adminTitles.CertificateNumber',
  [InsuredFields.emiratesIdNumber]: 'adminTitles.EmiratesIdNumber',
  [InsuredFields.dhaNumber]: 'adminTitles.DHAnumber',
  [InsuredFields.uadVisaNumber]: 'adminTitles.UADVisaNumber',
  [InsuredFields.maritalStatus]: 'adminTitles.MaritalStatus',
  [InsuredFields.sex]: 'leads.form.sex',
  [InsuredFields.maternalLastName]: 'adminTitles.maternalLastName',
  [InsuredFields.subGroup]: 'adminTitles.subGroup',
  [InsuredFields.additionalComments]: 'adminTitles.additionalComments',
  // files
  [InsuredFields.uadVisaNumberCdnFileId]: 'adminTitles.ScanOfUADvisa',
  [InsuredFields.passportCdnFileId]: 'adminTitles.scanOfPassport',
  [InsuredFields.emiratesIdNumberCdnFileId]: 'adminTitles.scanOfEmirates',
  // Deactivation
  [InsuredFields.contractCdnFileId]: 'adminTitles.ScanOfContract',
  [InsuredFields.deactivationDate]: 'adminTitles.DeactivationDate',
  [InsuredFields.principalFullName]: 'adminTitles.fullNameEmployee',
};
export const InsuredFieldsSettingsPlaceholder = {
  // Adding
  [InsuredFields.firstName]: 'adminTitles.EnterFirstName',
  [InsuredFields.lastName]: 'adminTitles.EnterLastName',
  [InsuredFields.birthDate]: 'adminTitles.datePickerPlaceholder',
  [InsuredFields.insuranceStartDate]: 'adminTitles.datePickerPlaceholder',
  [InsuredFields.insuranceBeginDate]: 'adminTitles.datePickerPlaceholder',
  [InsuredFields.insuranceEndDate]: 'adminTitles.datePickerPlaceholder',
  [InsuredFields.groupInsurancePolicyId]: 'adminTitles.SelectInsurancePolicy',
  [InsuredFields.insuredType]: 'adminTitles.SelectTypeOfInsured',
  [InsuredFields.phone]: 'adminTitles.phone',
  [InsuredFields.email]: 'adminTitles.EnterEmail',
  [InsuredFields.patronymicName]: 'adminTitles.EnterPatronymicName',
  [InsuredFields.citizenship]: 'adminTitles.nationalityPlaceholder',
  [InsuredFields.certificateNumber]: 'adminTitles.EnterCertificateNumber',
  [InsuredFields.emiratesIdNumber]: 'adminTitles.eidNoPlaceholder',
  [InsuredFields.dhaNumber]: 'adminTitles.dhaFileNoPlaceholder',
  [InsuredFields.uadVisaNumber]: 'adminTitles.visaNoPlaceholder',
  [InsuredFields.maritalStatus]: 'adminTitles.maritalStatusPlaceholder',
  [InsuredFields.sex]: 'leads.form.SelectSex',
  [InsuredFields.principalFullName]: 'adminTitles.EnterEmployeeFullName',
  [InsuredFields.maternalLastName]: 'adminTitles.enterMaternalLastName',
  [InsuredFields.subGroup]: 'adminTitles.enterSubGroup',
  [InsuredFields.additionalComments]: 'adminTitles.enterAdditionalComments',
  // Deactivation
  [InsuredFields.contractCdnFileId]: 'adminTitles.EnterScanOfContract',
  [InsuredFields.deactivationDate]: 'adminTitles.datePickerPlaceholder',
};
